import configuration from './configuration'
import data from './data'
import user from './user'
import modal from './modal'
import notifications from './notifications'

export default {
  configuration,
  data,
  user,
  modal,
  notifications
}
